import React, { Component } from 'react';
import styles from './radio.scss';

import Shortcuts from 'core/keyboard';
import { RadioFieldProps } from 'ui/form/fields';
import { isValue } from 'ui/form/utils';
interface RadioState {}

const ICONS = {
  on: <i className="material-icons">radio_button_checked</i>,
  off: <i className="material-icons">radio_button_unchecked</i>
};

let id = 0;
export default class Radio extends Component<RadioFieldProps, RadioState> {
  id = 'radio-' + id++;
  input: HTMLInputElement;
  state = {
    focus: false
  };

  focus = () => {
    if (this.input && !this.state.focus) this.input.focus({ preventScroll: true });
  };

  handleClick = (e: MouseEvent) => {
    // prevent radio from loosing focus
    e.preventDefault();
    // make sure it has focus
    this.focus();
    this.handleChange();
  };
  
  handleFocus = () => {
    this.setState({ focus: true });
    Shortcuts.onKey('enter', this.handleChange, true);
    Shortcuts.onKey('space', this.handleChange, true);
  };
  
  handleBlur = () => {
    this.setState({ focus: false });
    Shortcuts.offKey('enter', this.handleChange);
    Shortcuts.offKey('space', this.handleChange);
  };
  
  handleChange = () => {
    const { onChange, value } = this.props;
    
    if (onChange && isValue(value)) onChange(value);
  };
  
  render() {
    const { autoFocus, checked, index, label, name, tabIndex, value } = this.props;
    const { focus } = this.state;
    
    let cl = [styles.root];
    if (checked) cl.push(styles.on);
    if (focus) cl.push(styles.focus);
    
    const labelEl = isValue(value) ?
      <label htmlFor={this.id} style={label ? {} : { fontWeight: 600 }}>
        {label || JSON.stringify(value, null, 2)}
      </label> :
      <label htmlFor={this.id} className={styles.errorLabel}>Field is missing value</label>;
    
    return (
      <div className={cl.join(' ')} onMouseDown={this.handleClick}>
        <div className={styles.field}>
          <div className={styles.box}>
            {ICONS[checked ? 'on' : 'off']}
            <div className={styles.focusRing} />
          </div>
          {labelEl}
          <input
            type="radio"
            id={this.id}
            name={name}
            value={isValue(value) ? value : index}
            checked={checked}
            tabIndex={tabIndex}
            autoFocus={autoFocus}
            ref={ref => (this.input = ref)}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
          />
        </div>
      </div>
    );
  }
}
